import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-show-model',
  templateUrl: './show-model.component.html',
  styleUrls: ['./show-model.component.scss']
})
export class ShowModelComponent implements OnInit 
{

  constructor(private router:Router,private generalService :GeneralService,private dialogRef: MatDialogRef<ShowModelComponent>){}
  azerty;
  listeCaracteristiqueModelAll;
  listeCaracteristiqueModel;
  categorieModelSelected;
  ngOnInit() 
  {
    if(this.generalService.userConnecter == "")
    {
      this.router.navigate([""]);
    }
    else
      this.getListeCaracteristiqueModel();
  }
  getListeCaracteristiqueModel()
  {
    this.generalService.rechercheTable(this.generalService.urlListeModel).subscribe(data =>
    {
      this.listeCaracteristiqueModelAll = data
      this.listeCaracteristiqueModel =this.generalService.clone(data) ;
    })
  }
  onCaracteristiqueModelValuechange(e)
  {    
    var myList = this.listeCaracteristiqueModelAll;
    var list = myList.filter((val) => 
    {
      return val.ecArtCarMod_Label.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0;
    });
    if (list.length == 0) 
    {  
      list = myList;
      e.target.value = e.target.value.substr(0, (e.target.value.length - 1));
    }
    if(list.length == 1) 
    {
      this.caracteristiqueModelSelected({option:{value:{ecArtCarMod_Id:list[0].ecArtCarMod_Id}}})
    }
    this.listeCaracteristiqueModel = list;
  }
  caracteristiqueModelSelected(event)
  {      
    this.categorieModelSelected = this.listeCaracteristiqueModelAll.find(cat => { return cat.ecArtCarMod_Id == event.option.value.ecArtCarMod_Id});    
  }
  setTextInput(cat)
  {
    if(cat)
    {
      return cat.ecArtCarMod_Label
    }
  }
  save() 
  {
    if(this.categorieModelSelected != undefined)
      this.dialogRef.close(this.categorieModelSelected);
    else
      alert("Veuillez choisir un elément")
  }

  close() 
  {
    this.dialogRef.close("");
  }
}
